import { useEventCallback } from '@mui/material';
import { Fragment, ReactElement, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useNavigate } from 'react-router-dom';
import { NewMetricCrubs } from 'practice/constants/metric-crubs';
import FormMetric, { FormMetricVM } from 'practice/components/metric/form';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { toast } from 'react-toastify';
import { AxiosPromise } from 'axios';

const NewMetric = (): ReactElement => {
  const navigate = useNavigate();

  const onCancel = useEventCallback(() => {
    navigate('/pratiche/ricerca-metrica');
  });

  const insertMetric = useHttpClient(`${__PRACTICE_API_URL__}/pratiche/metrica/`, {
    options: {
      errorCatching: true,
      method: 'POST',
      loading: true,
      data: {},
    },
  });

  const onSubmit = useCallback(
    (values: FormMetricVM) => {
      const dataInsert = insertMetric({
        data: {
          dataDisattivazione: values.validityTo?.toFormat('yyyy-MM-dd') || undefined,
          numMaxOreOperazione: values.hoursMax || null,
          numOrePerWarning: values.hoursWarning || null,
          key: {
            tipoRegistro: values.register || undefined,
            tipoPratica: values.practice || undefined,
            tipoOperazione: values.operation || undefined,
            codStatoPratica: values.state || undefined,
            dataAttivazione: values.validityFrom?.toFormat('yyyy-MM-dd') || undefined,
          },
        },
      }) as AxiosPromise;
      dataInsert.then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/pratiche/ricerca-metrica');
      });
    },
    [insertMetric, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={NewMetricCrubs} />
      <FormMetric title="Nuova Metrica" onCancel={onCancel} onSubmit={onSubmit} />
    </Fragment>
  );
};

NewMetric.displayName = 'New Metric Page component';

export default NewMetric;
